import { Suspense } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import CharacterListResults from '~/components/SearchRoom/SearchResults/CharacterListResults';
import { Icon } from '~/components/atomic';
import { HelmetHead, IconButtonWrapper } from '~/components/common';
import { SearchRoomSkeleton } from '~/components/common/Skeleton';
import { Container, SearchHeader } from '../index';

export default function CharacterResult() {
  const navigate = useNavigate();
  const { state } = useLocation();

  return (
    <>
      <HelmetHead title='Characters' />

      <Container>
        <SearchHeader>
          <IconButtonWrapper onClick={() => navigate(-1)}>
            <Icon iconName='ArrowLeft' size={28} />
          </IconButtonWrapper>
        </SearchHeader>

        <Suspense fallback={<SearchRoomSkeleton />}>
          <Sentry.ErrorBoundary fallback={undefined}>
            <CharacterListResults query={state} isResultFull={true} />
          </Sentry.ErrorBoundary>
        </Suspense>
      </Container>
    </>
  );
}
